// export const localhost = "https://ticket-yctd.dri.io.vn";
export const localhost = "https://ticket.rainscales.com.vn";
// export const localhost = "http://10.2.21.89:2001";

export const urlAuthServer = "";
